export default "__VITE_ASSET__CEuIXHTE__"